import "./create-password.css";
import UpdatePassword from "../../components/UpdatePassword";
import { useSupabaseClient } from "@/hooks/useSupabaseClient";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "@/constant/routes";



const CreatePassword = () => {

    const onClick = async (password: string) => {
      
      const supabase = useSupabaseClient();
      const navigate = useNavigate();
      
      const { error } = await supabase.auth.updateUser({
        password
    });
   

    if (error) {
        console.log(error);
        return;
    }
    navigate(LOGIN);
    
    }

    return (
      <UpdatePassword 
        description={"Votre mot de passe doit contenir au moins 12 caractères, dont une majuscule, un chiffre et un symbole"} 
        title={"Création de votre mot de passe"}
        onClick={onClick}
      />
    );
};

export default CreatePassword